
















	import Vue from 'vue';
    import MenuItemListComp from "./MenuItemListComp.vue";
    import MenuToolbarComp from "./MenuToolbarComp.vue";

    export default Vue.extend({
        name: "MenuComp",
        props: ['show'],
        data: () => ({
            drawer: true,
        }),
        components: {
            MenuToolbarComp,
            MenuItemListComp,
        },
        methods: {
            toggleMenu: function(): void {
                this.drawer = !this.drawer;
            }
        }
    })

